export const MIN_DRAWER_HEIGHT = 40;

// CSS variable published on :root to expose the current draggable drawer height
export const APP_DRAGGABLE_DRAWER_HEIGHT_VAR = '--app-draggable-drawer-height';
